import React from 'react';

import { useAuth } from 'contexts/AuthContext';

import { Condition } from 'components/condition-list/SearchFilter';
import { NOTICE_TYPE_KEY } from 'stores/NoticeAdminStoreAdapter';

import NoticeManagementPage from './NoticeManagement';

/**
 * 個人向け通知（NOTICE）管理ページ
 * フィルター: ユーザー（単一選択）, タイトル, 期限あり, 作成日FROM, 作成日TO
 */
const AdminNoticeNoticePage: React.FC = () => {
  const { users } = useAuth();

  const conditions: Condition[] = React.useMemo(
    () => [
      {
        key: 'userId',
        name: 'ユーザー',
        type: 'user-select-single' as const,
        color: '#78C1F3',
        users,
      },
      {
        key: 'titleKeyword',
        name: 'タイトル',
        type: 'text' as const,
        color: '#3A98B9',
      },
      {
        key: 'hasDeadline',
        name: '期限あり',
        type: 'check' as const,
        color: '#F97B22',
        value: { key: 'true', name: '期限あり' },
      },
      {
        key: 'createdAtFrom',
        name: '作成日FROM',
        type: 'date-time-picker-start' as const,
        color: '#B799FF',
      },
      {
        key: 'createdAtTo',
        name: '作成日TO',
        type: 'date-time-picker-end' as const,
        color: '#B799FF',
      },
    ],
    [users],
  );

  return <NoticeManagementPage noticeType={NOTICE_TYPE_KEY.NOTICE} conditions={conditions} />;
};

export default AdminNoticeNoticePage;
